import axios from 'axios';
import { urlBaseEndpoint } from './index';
import type { SearchCaseRequest } from '@/types/types';

const endpoint = 'pdfexport';

const downloadBlob = (data: Blob, filename: string) => {
	const url = window.URL.createObjectURL(data);
	const link = document.createElement('a');
	link.href = url;
	link.download = filename;
	link.click();
	window.URL.revokeObjectURL(url);
};

export const exportBerichtPdf = async (request: SearchCaseRequest): Promise<void> => {
	const response = await axios({
		method: 'post',
		url: `${urlBaseEndpoint}/${endpoint}/bericht`,
		data: request,
		withCredentials: true,
		responseType: 'blob',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	const today = new Date().toISOString().slice(0, 10);
	downloadBlob(new Blob([response.data], { type: 'application/pdf' }), `Bericht_${today}.pdf`);
};
